<div class="tab-pane fade active show" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
    <div class="card">
        <div class="card-body">
            <form [formGroup]="gapInformation">
                <div class="form-row">
                    <label class="col-3" for="premiumRateApplied">Premium Rate Applied</label>
                    <div class="form-group col">
                        <div class="form-check form-check-inline">
                            <input type="radio" id="flatPremium" name="customRadio" class="form-check-input" formControlName="premiumRateApplied" name="premiumRateApplied" value="flatPremium">
                            <label class="form-check-label" for="flatPremium">Flat Premium</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input type="radio" id="perDollarRate" name="customRadio" class="form-check-input" formControlName="premiumRateApplied" name="premiumRateApplied" value="perDollarRate">
                            <label class="form-check-label" for="perDollarRate">Per-Dollar Rate</label>
                        </div>
                    </div>
                </div>
            </form>

            <h4>Flat Premiums based on Coverage Term Range</h4>
            <p class="subtitle"> Rates can be obtained from the GAP company.</p>

            <form [formGroup]="gapInformation">
                <ng-container formArrayName="terms">
                    <table class="table table-sm table-hover">
                        <thead>
                            <tr>
                                <th scope="col">Term Months From</th>
                                <th scope="col">Term Months To</th>
                                <th scope="col">Cost</th>
                                <th scope="col">Premium</th>
                                <th scope="col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (rangeForm of terms.controls; track rangeForm; let i = $index) {
                                <tr>
                                    <td><count-input [id]="'termMonthsFrom' + i" [control]="rangeForm.get('termMonthsFrom')"></count-input></td>
                                    <td><count-input [id]="'termMonthsTo' + i" [control]="rangeForm.get('termMonthsTo')"></count-input></td>
                                    <td><currency-input [id]="'cost' + i" [control]="rangeForm.get('cost')"></currency-input></td>
                                    <td><currency-input [id]="'premium' + i" [control]="rangeForm.get('premium')"></currency-input></td>
                                    <td class="actions"><button class="btn btn-link" (click)="discardTerms(i)"><span class="dripicons-trash text-danger"></span></button></td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </ng-container>
            </form>    
            <div class="card-footer">
                <button class="btn btn-sm btn-success" (click)="addTerms()"><span class="uil-plus"></span></button>
                <button class="btn btn-sm btn-primary" (click)="saveGAP()" [disabled]="!gapInformation.valid || contactId == 0">Save</button>
            </div>
        </div>
    </div>
    @if (calledFrom == null) {
    <div class="text-right">
        <button class="btn btn-sm btn-danger" (click)="deactivateRole()">Deactivate Role</button>
    </div>
    }
</div>
